import { API_USER_PREFIX, API_USER_ROLE_PREFIX } from '@shared/config/api/api-prefixes';
import { UserApi } from './base';
import {
    UserPreviewDataRequest,
    UserPreviewDataResponse,
    UserRolesListDataRequest,
    UserRolesListDataResponse,
    UsersListManagemntDataRequest,
    UsersListManagemntDataResponse,
} from './user-management-types';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';

export const userApi = UserApi.injectEndpoints({
    endpoints: (build) => ({
        usersList: build.query<UsersListManagemntDataResponse, UsersListManagemntDataRequest>({
            query: (parameters) => `${API_USER_PREFIX}${queryParametersToString({ ...parameters })}`,
            providesTags: ['UsersList'],
        }),
        userPreview: build.query<UserPreviewDataResponse, UserPreviewDataRequest>({
            query: (id) => `${API_USER_PREFIX}/${id}/preview`,
        }),
        userRolesList: build.query<UserRolesListDataResponse, UserRolesListDataRequest>({
            query: ({ take, search, skip }) =>
                `${API_USER_ROLE_PREFIX}${queryParametersToString({ take, search, skip })}`,
        }),
    }),
});

export const {
    useLazyUsersListQuery,
    useUserRolesListQuery,
    useLazyUserPreviewQuery,
    usePrefetch: useUserApiPrefetch,
} = userApi;
